/**
 * Payable order total for display.
 * PILOT orders (v2, admin create) store `total` as net: subtotal + shipping - discount.
 * Legacy Prana-converted orders store gross `total` (subtotal + shipping); discount is separate.
 */
export function getOrderPayableTotal(order) {
  if (!order) return 0;

  const discount =
    parseFloat(order.discount) || parseFloat(order.coupon_discount_amount) || 0;
  const total = parseFloat(order.total);

  if (order.orderFrom === 'PILOT' && Number.isFinite(total)) {
    return total;
  }

  if (Number.isFinite(total) && total > 0) {
    if (discount > 0) {
      return Math.max(0, total - discount);
    }
    return total;
  }

  const fallback =
    parseFloat(order.order_amount) ||
    parseFloat(order.amount) ||
    parseFloat(order.totalAmount) ||
    0;

  if (discount > 0 && fallback > 0) {
    return Math.max(0, fallback - discount);
  }

  return fallback;
}

export function getOrderSubtotal(order) {
  if (!order) return 0;
  const subtotal = parseFloat(order.subtotal);
  if (Number.isFinite(subtotal)) return subtotal;
  const orderAmount = parseFloat(order.order_amount) || 0;
  const shipping = parseFloat(order.shipping_cost) || parseFloat(order.shippingCost) || 0;
  return Math.max(0, orderAmount - shipping);
}

export function getOrderShippingCost(order) {
  if (!order) return 0;
  return parseFloat(order.shippingCost) || parseFloat(order.shipping_cost) || 0;
}

export function getOrderDiscount(order) {
  if (!order) return 0;
  return parseFloat(order.discount) || parseFloat(order.coupon_discount_amount) || 0;
}

export function getOrderAppliedCoupon(order) {
  return order?.appliedCoupon || order?.coupon_code || null;
}
